import React from "react";
import {connect} from "formik";
import CustomButton from "../../../CustomButton";


const SubmitButton = ({formik, className, children}) => (
    <CustomButton
        className={`submit-button${className ? ' ' + className : ''}`}
        type="submit"
        disabled={!(formik.dirty && formik.isValid)}
    >
        {children}
    </CustomButton>
);

export default connect(SubmitButton);